import type { ComponentType } from 'react';
import {
  FilePdfOutlined,
  FileWordOutlined,
  FileTextOutlined,
  FileUnknownOutlined,
  FileImageOutlined,
} from '@ant-design/icons';

const fileIcons: Record<string, ComponentType> = {
  pdf: FilePdfOutlined,
  docx: FileWordOutlined,
  txt: FileTextOutlined,
  jpg: FileImageOutlined,
  jpeg: FileImageOutlined,
  png: FileImageOutlined,
  gif: FileImageOutlined,
  bmp: FileImageOutlined,
  svg: FileImageOutlined,
};

const getFileExtension = (filename: string | undefined | null): string => {
  if (!filename || typeof filename !== 'string') {
    return 'unknown';
  }
  const parts = filename.split('.');
  return parts.length > 1 ? parts.pop() || 'unknown' : 'unknown';
};

const generateIcons = (filename: string) => {
  const extension = getFileExtension(filename);
  if (!extension) return FileUnknownOutlined;
  return fileIcons[extension] || FileUnknownOutlined;
};

export const FileIconComponent = (
  filename: string | undefined | null,
  link?: string,
  fontSize: number = 16,
  isGreyedOut: boolean = false,
) => {
  const safeFilename = filename || 'unknown';
  const Icon = generateIcons(safeFilename);
  const greyedOutStyle = isGreyedOut
    ? { color: '#999', opacity: 0.6 }
    : { color: 'black' };

  return (
    <span
      style={{
        display: 'flex',
        gap: 5,
        padding: '0 15px',
        alignItems: 'center',
      }}
    >
      <Icon style={{ fontSize: fontSize, ...greyedOutStyle }} />
      {!link ? (
        <span style={greyedOutStyle}>{safeFilename}</span>
      ) : (
        <a
          target="_blank"
          onClick={(e: any) => e.preventDefault()}
          rel="noopener noreferrer"
          style={greyedOutStyle}
          title={safeFilename}
        >
          {safeFilename}
        </a>
      )}
    </span>
  );
};
